import { Model } from '@chaysehartsuff/active-html';

export default class User extends Model {

    id;
    name;
    email;
    email_verified_at;
    created_at;
    updated_at;

    constructor(get_auth_user = true) {
        super();
        if(get_auth_user){
            this.getSync();
        }
    }

}